<template>
    <v-dialog :value="value" @input="$emit('input', $event)" max-width="800px" scrollable>
        <v-card v-if="item">
            <v-card-title class="primary white--text">
                <v-icon left color="white">inventory_2</v-icon>
                {{ item.titolo }}
            </v-card-title>

            <v-divider />

            <v-card-text class="pt-6">
                <div class="mb-4">
                    <div class="text-overline grey--text">Contesto</div>
                    <div class="text-body-1" style="white-space: pre-wrap;">{{ item.contesto }}</div>
                </div>

                <v-row>
                    <v-col cols="6" sm="3">
                        <div class="text-overline grey--text">Linguaggio</div>
                        <v-chip small>{{ item.stack }}</v-chip>
                    </v-col>
                    <v-col cols="6" sm="3">
                        <div class="text-overline grey--text">Maturità</div>
                        <v-chip small :color="maturitaColor(item.maturita)" text-color="white">
                            {{ maturitaLabel(item.maturita) }}
                        </v-chip>
                    </v-col>
                    <v-col cols="6" sm="3">
                        <div class="text-overline grey--text">Autore</div>
                        <div>{{ item.autore }}</div>
                    </v-col>
                    <v-col cols="6" sm="3">
                        <div class="text-overline grey--text">Pubblicato il</div>
                        <div>{{ formatData(item.dataPubblicazione) }}</div>
                    </v-col>
                </v-row>

                <v-row>
                    <v-col cols="12" sm="6">
                        <div class="text-overline grey--text">Progetto</div>
                        <div>{{ item.repo }}</div>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <div class="text-overline grey--text">Percorso file</div>
                        <div class="text-break">{{ item.pathFile }}</div>
                    </v-col>
                </v-row>

                <div class="mb-4" v-if="item.linkCodePermalink">
                    <div class="text-overline grey--text">Link al codice git</div>
                    <a :href="item.linkCodePermalink" target="_blank" rel="noopener noreferrer">
                        {{ item.linkCodePermalink }}
                        <v-icon x-small>open_in_new</v-icon>
                    </a>
                </div>

                <div class="mb-4" v-if="tagList.length > 0">
                    <div class="text-overline grey--text mb-1">Tag</div>
                    <v-chip small v-for="tag in tagList" :key="tag" class="mr-1 mb-1">{{ tag }}</v-chip>
                </div>

                <div v-if="item.snippetCodice">
                    <div class="text-overline grey--text mb-1">Snippet</div>
                    <pre class="snippet-codice"><code v-html="snippetEvidenziato"></code></pre>
                </div>

                <div class="text-caption grey--text mt-4">
                    Ultimo aggiornamento: {{ formatData(item.dataAggiornamento) }}
                </div>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-spacer />
                <v-btn text @click="$emit('input', false)">Chiudi</v-btn>
                <v-btn color="primary" v-if="puoModificare" @click="$emit('modifica', item)">
                    <v-icon left>edit</v-icon>
                    Modifica
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import hljs from 'highlight.js';
import 'highlight.js/styles/github.css';

export default {
    name: 'CatalogoDetailDrawer',

    props: {
        value: {
            type: Boolean,
            default: false
        },
        item: {
            type: Object,
            default: null
        }
    },

    computed: {
        tagList() {
            if (!this.item || !this.item.tag) return [];
            return this.item.tag.split(',').map(t => t.trim()).filter(t => t.length > 0);
        },

        snippetEvidenziato() {
            if (!this.item || !this.item.snippetCodice) return '';
            return hljs.highlightAuto(this.item.snippetCodice).value;
        },

        puoModificare() {
            if (!this.item) return false;
            const utente = this.$store.getters['user/getNome'];
            const ruolo = this.$store.getters['user/getRole'];
            return ruolo === 'admin' || (utente && utente.toLowerCase() === (this.item.autore || '').toLowerCase());
        }
    },

    methods: {
        formatData(data) {
            if (!data) return '-';
            return this.$i2kFunctions.formatISODate(data);
        },

        maturitaLabel(maturita) {
            const labels = {
                grezzo: 'Grezzo',
                rodato: 'Rodato',
                non_riusare: 'Non riusare'
            };
            return labels[maturita] || maturita;
        },

        maturitaColor(maturita) {
            const colors = {
                grezzo: 'orange',
                rodato: 'success',
                non_riusare: 'error'
            };
            return colors[maturita] || 'grey';
        },
    }
};
</script>

<style scoped>
.snippet-codice {
    background-color: #f5f5f5;
    border-radius: 4px;
    padding: 12px;
    overflow-x: auto;
    max-width: 100%;
}
</style>
